export const LOADING = 'LOADING';
export const MENU_TOGGLE = 'MENU_TOGGLE';
export const BROADCAST_START = 'BROADCAST_START';
export const BROADCAST_END = 'BROADCAST_END';
export const DIALOG_OPEN = 'DIALOG_OPEN';
export const DIALOG_CLOSE = 'DIALOG_CLOSE';

// --- DATA MODEL --- //

export enum BroadcastType
{
    INFO,
    SUCCESS,
    WARNING,
    ERROR
}

export interface OverlayState
{
    menuOpen: boolean;
    loading: boolean;
    broadcast: BroadcastState;
    dialog: DialogState;
}

export interface BroadcastState
{
    open: boolean;
    type: BroadcastType;
    message: string;
}

export interface DialogState
{
    open: boolean;
    content: JSX.Element|null;
}

// --- ACTION MODEL --- //

interface LoadingAction
{
    type: typeof LOADING;
    value: boolean;
}

interface BroadcastAction
{
    type: typeof BROADCAST_START | typeof BROADCAST_END;
    value: {
        open: boolean;
        type?: BroadcastType;
        message: string|JSX.Element;
    }
}

interface DialogAction
{
    type: typeof DIALOG_OPEN | typeof DIALOG_CLOSE;
    value: DialogState;
}

interface MenuToggleAction
{
    type: typeof MENU_TOGGLE;
}

export type OverlayAction = LoadingAction | BroadcastAction | MenuToggleAction | DialogAction;

// ------------------- //